export enum IaoEventTypeEnum {
  ShowNext,
  Start,
  Stop,
}
